"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    title: () => ({
        marginTop: theme.spacing(4),
    }),
    description: () => ({
        marginTop: theme.spacing(1),
        maxWidth: 212,
        textAlign: 'center',
    }),
    emptyIcon: {
        height: 150,
        width: 150,
    },
}));
const NotificationPlaceholder = ({ title, description, icon }) => {
    const classes = useStyles();
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", children: [icon || (0, jsx_runtime_1.jsx)(silhouette_core_1.PlaceholderNotificationIcon, { className: classes.emptyIcon }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2-medium", color: "inherit", title: title, className: classes.title, children: title }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "caption", color: "inherit", title: description, className: classes.description, children: description })] }) }) }));
};
exports.NotificationPlaceholder = NotificationPlaceholder;
//# sourceMappingURL=NotificationPlaceholder.js.map